/**
 * Route guard (P0-TR4, SEC-3).
 *
 * Cosmetic only, and deliberately so. Every rule that matters is enforced by
 * the API — hiding a screen stops a partner wandering into it, it does not
 * stop anyone who bypasses the UI. `authorize(...roles)` on the server is the
 * real guard.
 */

import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../features/auth/AuthContext.js';
import { useTranslation } from '../i18n/useTranslation.js';

export function ProtectedRoute({ children }: { children: JSX.Element }): JSX.Element {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  // Without this the app flashes the login screen on every reload while the
  // silent refresh is still in flight (P0-BR3).
  if (isLoading) {
    return (
      <p role="status" className="p-6 text-center text-gray-500">
        {t('app.loading')}
      </p>
    );
  }

  if (!user) {
    // `state` lets the login screen send the partner back where they were
    // heading, rather than dumping them on the dashboard.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
